module.exports = __webpack_public_path__ + "static/media/firebaselogo.e642c755.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/firebaselogo.png
// module id = 833
// module chunks = 0